import React, { useState, useEffect } from 'react';
import { FaMapMarkerAlt, FaClipboardList, FaShoppingBag, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import './LinksPage.css';
import { getLinks, setLinks } from '../services/linktreeService';

const ICON_OPTIONS = [
  { name: 'Map', icon: <FaMapMarkerAlt /> },
  { name: 'Clipboard', icon: <FaClipboardList /> },
  { name: 'Bag', icon: <FaShoppingBag /> },
  { name: 'Instagram', icon: <FaInstagram /> },
  { name: 'WhatsApp', icon: <FaWhatsapp /> },
];

const defaultLinks = [
  {
    icon: 'Map',
    label: 'Visit our Al Wakrah branch',
    url: 'https://maps.app.goo.gl/9Dn4GvEbAEnGdHUA9',
    sublabel: 'Open daily 7 AM - 11 PM',
  },
  {
    icon: 'Map',
    label: 'Visit our Gewan Island branch',
    url: 'https://maps.app.goo.gl/tLp1jS6tT8sR4kGg9',
    sublabel: 'Open daily 8 AM - 12 AM',
  },
  {
    icon: 'Clipboard',
    label: 'View Gewan Menu',
    url: '/menu/gewan',
    sublabel: '',
  },
  {
    icon: 'Bag',
    label: 'Admin Panel',
    url: '/admin',
    sublabel: '',
  },
];

function getIconByName(name) {
  const found = ICON_OPTIONS.find(opt => opt.name === name);
  return found ? found.icon : null;
}

const AdminLinksPage = () => {
  const [links, setLinksState] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [form, setForm] = useState({ icon: 'Map', label: '', url: '', sublabel: '' });
  const [saveMsg, setSaveMsg] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    getLinks().then(fetched => {
      setLinksState(fetched.length ? fetched : defaultLinks);
      setLoading(false);
    }).catch(() => {
      setLinksState(defaultLinks);
      setError('Failed to load links from server.');
      setLoading(false);
    });
  }, []);

  const handleEdit = idx => {
    setEditingIndex(idx);
    setForm(links[idx]);
  };
  const handleDelete = idx => {
    if (window.confirm('Delete this link?')) {
      const newLinks = links.filter((_, i) => i !== idx);
      setLinksState(newLinks);
    }
  };
  const handleSave = () => {
    if (!form.label || !form.url) return;
    const updated = { ...form };
    let newLinks;
    if (editingIndex !== null) {
      newLinks = links.map((l, i) => (i === editingIndex ? updated : l));
    } else {
      newLinks = [...links, updated];
    }
    setLinksState(newLinks);
    setEditingIndex(null);
    setForm({ icon: 'Map', label: '', url: '', sublabel: '' });
  };
  const handleCancel = () => {
    setEditingIndex(null);
    setForm({ icon: 'Map', label: '', url: '', sublabel: '' });
  };
  const handleSaveAll = async () => {
    try {
      await setLinks(links);
      setSaveMsg('Links saved!');
      setTimeout(() => setSaveMsg(''), 1800);
    } catch {
      setSaveMsg('Error saving links!');
      setTimeout(() => setSaveMsg(''), 1800);
    }
  };

  return (
    <div className="links-page-container">
      <div className="links-page-card" style={{ maxWidth: 600, textAlign: 'left' }}>
        <h2 style={{ textAlign: 'center', fontWeight: 700, fontSize: 22, marginBottom: 24 }}>Manage Linktree Links</h2>
        {loading ? <div style={{textAlign:'center',margin:'32px 0'}}>Loading...</div> : null}
        {error && <div style={{color:'#e11d48',textAlign:'center',marginBottom:12}}>{error}</div>}
        <ul style={{ listStyle: 'none', padding: 0, margin: 0, marginBottom: 32 }}>
          {links.map((link, idx) => (
            <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18, background: '#fafafa', borderRadius: 10, padding: '12px 16px' }}>
              <span style={{ fontSize: 22 }}>{getIconByName(link.icon)}</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600 }}>{link.label}</div>
                {link.sublabel && <div style={{ fontSize: 13, color: '#888' }}>{link.sublabel}</div>}
                <div style={{ fontSize: 13, color: '#aaa' }}>{link.url}</div>
              </div>
              <button onClick={() => handleEdit(idx)} style={{ marginRight: 8 }}>Edit</button>
              <button onClick={() => handleDelete(idx)} style={{ color: '#e11d48' }}>Delete</button>
            </li>
          ))}
        </ul>
        <div style={{ borderTop: '1px solid #eee', margin: '18px 0' }}></div>
        <div style={{ marginBottom: 12, fontWeight: 600 }}>{editingIndex !== null ? 'Edit Link' : 'Add New Link'}</div>
        <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
          <select value={form.icon} onChange={e => setForm(f => ({ ...f, icon: e.target.value }))}>
            {ICON_OPTIONS.map(opt => (
              <option key={opt.name} value={opt.name}>{opt.name}</option>
            ))}
          </select>
          <input placeholder="Label" value={form.label} onChange={e => setForm(f => ({ ...f, label: e.target.value }))} style={{ flex: 2 }} />
          <input placeholder="Sublabel (optional)" value={form.sublabel} onChange={e => setForm(f => ({ ...f, sublabel: e.target.value }))} style={{ flex: 2 }} />
          <input placeholder="URL" value={form.url} onChange={e => setForm(f => ({ ...f, url: e.target.value }))} style={{ flex: 3 }} />
        </div>
        <div style={{ display: 'flex', gap: 10, marginBottom: 24 }}>
          <button onClick={handleSave} style={{ background: '#222', color: '#fff', borderRadius: 8, padding: '8px 18px', border: 'none', fontWeight: 600 }}>{editingIndex !== null ? 'Save' : 'Add'}</button>
          {editingIndex !== null && <button onClick={handleCancel} style={{ background: '#eee', borderRadius: 8, padding: '8px 18px', border: 'none' }}>Cancel</button>}
        </div>
        <button onClick={handleSaveAll} style={{ background: '#1e293b', color: '#fff', borderRadius: 8, padding: '10px 28px', border: 'none', fontWeight: 700, fontSize: 16, width: '100%', marginBottom: 8 }}>Save All Links</button>
        {saveMsg && <div style={{ color: '#059669', textAlign: 'center', marginTop: 8, fontWeight: 600 }}>{saveMsg}</div>}
      </div>
    </div>
  );
};

export default AdminLinksPage; 